import { render, staticRenderFns } from "./AccReceivableCashReg.vue?vue&type=template&id=1015f838&"
import script from "./AccReceivableCashReg.vue?vue&type=script&lang=js&"
export * from "./AccReceivableCashReg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports